import { createSelector } from '@reduxjs/toolkit';
import { StateSchema } from 'app/providers/StoreProvider';

export const getBalanceState = (state: StateSchema) => state.balance;

export const getAllAvailableTokensData = createSelector(getBalanceState, (balance) => balance?.availableTokens ?? []);
